module.exports = __webpack_public_path__ + "img/DrySystem-Profiles.fbafa93a.jpg";